<template>
  <div v-if="show" class="devices_stat">

    <h4 class="title">
      Users Stat
    </h4>

    <div class="statictics">
      <div v-for="(stat, key_stat) in users_stat" :key="key_stat" class="stat">
        <template v-if="typeof(stat) == 'object'">
          <h5>{{ key_stat }}:</h5>
          <p v-for="(item, key_item) in stat" :key="key_item">
            <span>{{ key_item }}: </span>
            <span>{{ item }}</span>
          </p>
        </template>
        <template v-else>
          <span>{{ key_stat }}: </span>
          <span>{{ stat }}</span>
        </template>
      </div>
    </div>

  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>

export default {
  name: 'UsersStats',
  components: {
  },
  props: ['users_stat'],
  data () {
    return {
      loading: false,
      show: true,
      temp: '',
      date: [],
      actions: []
    }
  },

  mounted () {
  },

  watch:{

  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {

  },
}

</script>
<style lang='scss' scoped>
  .devices_stat{
    padding: 5px;
    .title{
      margin-bottom: 10px;
    }
    .statictics{
      .stat{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        p, span{
          margin: 0;
          font-size: 16px;
          margin-right: 5px;
          &:last-child{
            margin-right: 0;
          }
        }
        h5{
          margin: 0 5px 0 0;
          font-size: 16px;
        }
      }
    }
  }
</style>
